import TempService from "../../services";
import { hasError } from "@/utils/utils";
export default {
  actions: {
    async addNgoInfo({ commit, dispatch }, payload) {
      commit("TempNgo/setWorking", true, { root: true });
      console.log("payload" , payload)
      try {
        const res = await TempService.addNgoInfo(payload);
        commit("TempNgo/setWorking", false, { root: true });

        if (hasError(res.status)) {
          throw res.status;
        }
      
        dispatch("fetchNgoData");
        // dispatch("changeCurrentStage");
        return Promise.resolve();
      } catch (err) {
        console.log("err" , err)
        return Promise.reject(err);
      }
    },
    async updateNgoInfo({ commit, dispatch }, payload) {
      commit("TempNgo/setWorking", true, { root: true });
      try {
        const res = await TempService.updateTempNgoInfo(payload);
        commit("TempNgo/setWorking", false, { root: true });

        if (hasError(res.status)) {
          throw res.statusText;
        }
        dispatch("fetchNgoData");
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      }
    },
  },
};
